module.exports = __webpack_public_path__ + "static/media/facileristrutturare-logo.badb56e1.svg";